import { BaseError } from "./BaseError.ts";

export function getUserPresentableMessage(error: unknown): string | undefined;
export function getUserPresentableMessage(
  error: unknown,
  fallback: string,
): string;
export function getUserPresentableMessage(
  error: unknown,
  fallback?: string,
): string | undefined {
  const message =
    error instanceof BaseError ? error.userPresentableMessage : undefined;

  return message ?? fallback;
}
